export function useLoading(){

  const pageLoadingFlag = ref(true);

  setTimeout(() => {
    pageLoadingFlag.value = false;
  }, 5000);

  /**
   * 显示loading
   */
  const showLoading=function (){
    pageLoadingFlag.value=true;
    setTimeout(() => {
      pageLoadingFlag.value = false;
    }, 5000);
  }


  return {
    showLoading,
    pageLoadingFlag
  }
}
